import { createCustomError } from '@ori/error';
import type { NonOptionalKeys } from '@ori/ts-utils';

import { MISSING_PROPERTY } from './constants';
import { isValidClientAppConfigProperty, safeParseJson } from './internals';

export const ParseClientAppConfigError = createCustomError('ParseClientAppConfigError', {
  MISSING_PROPERTY,
});

/**
 * Parses and validates a JSON string into an object typed by provided type as client application configuration.
 * JSON string can be obtained e.g. from HTML attribute `data-config` of the client application root element.
 * @param config A JSON string. Preferably valid. Invalid JSON string throws an error.
 * @param requiredProperties Properties required by the client application. Properties are validated if exist in client application configuration and have a valid value. Otherwise an error is thrown.
 * @returns Valid client application configuration.
 */
export function parseClientAppConfig<T>(config: string, requiredProperties: Array<NonOptionalKeys<T>> = []) {
  const parsedClientAppConfig = safeParseJson<T>(config);

  requiredProperties.forEach((property) => {
    if (!isValidClientAppConfigProperty(parsedClientAppConfig as Record<string, unknown>, String(property))) {
      throw new ParseClientAppConfigError('MISSING_PROPERTY', { messageParameters: [String(property)] });
    }
  });

  return parsedClientAppConfig;
}
